export default __webpack_public_path__ + "static/media/Fachkraft.e1423d50.svg";